"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toFixed(number, precision) {
    // eslint-disable-next-line
    var multiplier = Math.pow(10, precision + 1);
    var wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
// transform to vw
function transformToVw(value) {
    var defaults = {
        viewportWidth: 750,
        viewportUnit: 'vw',
        unitPrecision: 5,
    };
    var pixels = parseFloat(value);
    var parsedVal = toFixed(pixels / defaults.viewportWidth * 100, defaults.unitPrecision);
    return parsedVal + defaults.viewportUnit;
}
;
exports.default = transformToVw;
